<script setup lang="ts">
import { watch } from 'vue'
import { useDeployLockStore } from '@/stores/deployLock'
import { useNotificationsStore } from '@/stores/notifications'
import { useAuthStore } from '@/stores/auth'
import AppToastContainer from '@/components/layout/AppToastContainer.vue'

const deployLockStore = useDeployLockStore()
const notificationsStore = useNotificationsStore()
const authStore = useAuthStore()

// Démarrer le polling uniquement quand l'utilisateur est authentifié
// Évite la boucle 401 → refresh → reload quand l'app démarre sans session valide
watch(
  () => authStore.isAuthenticated,
  (isAuth) => {
    if (isAuth) {
      deployLockStore.startPolling()
    } else {
      deployLockStore.stopPolling()
    }
  },
  { immediate: true },
)
</script>

<template>
  <RouterView />
  <AppToastContainer :toasts="notificationsStore.toasts" @clear="notificationsStore.clearToast" />
</template>
